export default "__VITE_ASSET__BygCOhZn__"